import React from "react";
import { ArrowRightIcon, MousePointer2Icon } from "lucide-react";
type ButtonLinkProps = {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "secondaryDark" | "ghost";
  className?: string;
  analytics?: string;
  external?: boolean;
};
function ButtonLink({
  href,
  children,
  variant = "primary",
  className = "",
  analytics,
  external = false
}: ButtonLinkProps) {
  const styles = {
    primary: "group bg-pfpc-orange text-pfpc-navy border border-pfpc-orange hover:bg-[#f07b41] active:translate-y-px focus-visible:ring-pfpc-orange",
    secondary: "group bg-transparent text-pfpc-navy border border-pfpc-navy/35 hover:bg-pfpc-navy hover:text-pfpc-offwhite focus-visible:ring-pfpc-navy",
    secondaryDark: "group bg-transparent text-pfpc-offwhite border border-pfpc-offwhite/45 hover:bg-pfpc-offwhite hover:text-pfpc-navy focus-visible:ring-pfpc-offwhite",
    ghost: "group text-current underline decoration-current/30 underline-offset-4 hover:decoration-current focus-visible:ring-current"
  };
  const Icon = variant === "primary" ? MousePointer2Icon : ArrowRightIcon;
  return <a href={href} data-analytics={analytics} className={`inline-flex min-h-12 items-center justify-center gap-2 rounded-[10px] px-5 py-3 text-[15px] font-bold leading-none transition duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${styles[variant]} ${className}`} {...external ? {
    target: "_blank",
    rel: "noreferrer"
  } : {}} data-id="element-176" data-mp="1yz382fq9cbli">
      <span data-id="element-177" data-mp="1g4ek95un0htk">{children}</span>
      <Icon aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} data-id="element-178" data-mp="1l1n4dbzcivxg" />
    </a>;
}
export { ButtonLink };